import { RivalsAppProps, RivalsPageProps } from "rivals/Context";
import Subscribe from "rivals/components/pages/Registration/Subscribe/container";
import { getRailsConstants } from "rivals/redux/rails/actions";
import { RailsConstantsKeys } from "rivals/redux/rails/reducer";
import { getAddonsForSubscription } from "rivals/redux/subscriptionAddons/actions";
import styles from "./Subscribe.module.scss";

const COMPONENTS = [
  RailsConstantsKeys.BILLING_INFORMATION,
  RailsConstantsKeys.SUBSCRIPTION_PRICING
];

interface OwnProps {
  showAuthenticatedLinks: boolean;
}

type Props = RivalsPageProps & OwnProps;

function SubscribePage(): JSX.Element {
  return (
    <main className={styles.wrapper} role="main">
      <Subscribe />
    </main>
  );
}

SubscribePage.getInitialProps = async ({
  isServer,
  store: { dispatch }
}: RivalsAppProps): Promise<Props> => {
  dispatch(getRailsConstants(COMPONENTS));
  dispatch(getAddonsForSubscription());

  return {
    isServer,
    showAuthenticatedLinks: false
  };
};

export default SubscribePage;
